import { flowRight } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withTranslate from '../../../common/components/with-translate/with-translate';
import CardHeaderLeftSide from './card-header-left-side';
import UserAvatarImage from '../user-avatar-image';
import ProfileLink from '../link/profile-link';
import { PinIcon } from '../icons/pin-icon';
import MemberCardAsync from '../../containers/member-card-async';
import styles from './post-page-card-header.scss';
import AvatarImage from '../avatar-image';
import withExperiment from '../../hoc/with-experiment';
import { EXPERIMENT_WIX_COMMENTS } from '@wix/communities-forum-client-commons/dist/src/constants/experiments';

class PostPageCardHeader extends Component {
  renderPinIcon = () => (
    <div data-hook="pin-icon">
      <PinIcon
        className="icon-secondary-fill"
        aria-label={this.props.t('post-list-item.pinned-post')}
        isPinned
      />
    </div>
  );
  render() {
    const { post, isWixCommentsEnabled } = this.props;
    const user = post.owner || {};
    const date = post.createdDate;
    return (
      <div className={styles.header}>
        <div className={styles.headerLeftSide}>
          <ProfileLink user={user}>
            <MemberCardAsync
              className={styles.avatar}
              viewedMemberId={user.siteMemberId}
              viewedMemberSlug={user.slug}
            >
              <UserAvatarImage
                user={user}
                type={isWixCommentsEnabled ? AvatarImage.POST_PAGE_HEADER : AvatarImage.POST_PAGE}
              />
            </MemberCardAsync>
          </ProfileLink>
          <CardHeaderLeftSide user={user} date={date} />
        </div>
        <div className={styles.headerRightSide}>{post.isPinned && this.renderPinIcon()}</div>
      </div>
    );
  }
}

PostPageCardHeader.propTypes = {
  post: PropTypes.object.isRequired,
};

export default flowRight(
  withTranslate,
  withExperiment({
    isWixCommentsEnabled: EXPERIMENT_WIX_COMMENTS,
  }),
)(PostPageCardHeader);
